import { MatTreeFlattener } from '@angular/material/tree';

import { RdsFlatNavTreeItem } from './flat-nav-tree-item.model';
import { RdsNavTreeItem } from './nav-tree-item.model';

export const rdsNavTreeFlattener = new MatTreeFlattener<RdsNavTreeItem, RdsFlatNavTreeItem>(
  (node: RdsNavTreeItem, level: number) => new RdsFlatNavTreeItem(node, level),
  (node) => node.level,
  (node) => !!node.children?.length,
  (node) => node.children
);
